import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** clock. Decorative line icon; always pair with a visible text label. */
export function ClockIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </IconSvg>
  )
}
